import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Inject, ContentChildren, Output } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { DOCUMENT } from '@angular/common';
import { PROPERTY_TOKEN_annotations, PROPERTY_TOKEN_constantLines, PROPERTY_TOKEN_strips, PROPERTY_TOKEN_series } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoPolarChartAdaptiveLayoutComponent = /*#__PURE__*/(() => {
  class DxoPolarChartAdaptiveLayoutComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get keepLabels() {
      return this._getOption('keepLabels');
    }
    set keepLabels(value) {
      this._setOption('keepLabels', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'adaptiveLayout';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartAdaptiveLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAdaptiveLayoutComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartAdaptiveLayoutComponent,
      selectors: [["dxo-polar-chart-adaptive-layout"]],
      inputs: {
        height: "height",
        keepLabels: "keepLabels",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartAdaptiveLayoutComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartAdaptiveLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartAdaptiveLayoutModule = /*#__PURE__*/(() => {
  class DxoPolarChartAdaptiveLayoutModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartAdaptiveLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAdaptiveLayoutModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartAdaptiveLayoutModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartAdaptiveLayoutComponent]
    });
  }
  return DxoPolarChartAdaptiveLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartAnimationComponent = /*#__PURE__*/(() => {
  class DxoPolarChartAnimationComponent extends NestedOption {
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get maxPointCountSupported() {
      return this._getOption('maxPointCountSupported');
    }
    set maxPointCountSupported(value) {
      this._setOption('maxPointCountSupported', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartAnimationComponent,
      selectors: [["dxo-polar-chart-animation"]],
      inputs: {
        duration: "duration",
        easing: "easing",
        enabled: "enabled",
        maxPointCountSupported: "maxPointCountSupported"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartAnimationModule = /*#__PURE__*/(() => {
  class DxoPolarChartAnimationModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartAnimationComponent]
    });
  }
  return DxoPolarChartAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartAnnotationBorderComponent = /*#__PURE__*/(() => {
  class DxoPolarChartAnnotationBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartAnnotationBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAnnotationBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartAnnotationBorderComponent,
      selectors: [["dxo-polar-chart-annotation-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartAnnotationBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartAnnotationBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartAnnotationBorderModule = /*#__PURE__*/(() => {
  class DxoPolarChartAnnotationBorderModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartAnnotationBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAnnotationBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartAnnotationBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartAnnotationBorderComponent]
    });
  }
  return DxoPolarChartAnnotationBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPolarChartAnnotationComponent = /*#__PURE__*/(() => {
  class DxiPolarChartAnnotationComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get angle() {
      return this._getOption('angle');
    }
    set angle(value) {
      this._setOption('angle', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get radius() {
      return this._getOption('radius');
    }
    set radius(value) {
      this._setOption('radius', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'annotations';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPolarChartAnnotationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartAnnotationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPolarChartAnnotationComponent,
      selectors: [["dxi-polar-chart-annotation"]],
      inputs: {
        allowDragging: "allowDragging",
        angle: "angle",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        name: "name",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        radius: "radius",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_annotations,
        useExisting: DxiPolarChartAnnotationComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiPolarChartAnnotationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiPolarChartAnnotationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPolarChartAnnotationModule = /*#__PURE__*/(() => {
  class DxiPolarChartAnnotationModule {
    /** @nocollapse */static ɵfac = function DxiPolarChartAnnotationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartAnnotationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPolarChartAnnotationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiPolarChartAnnotationComponent]
    });
  }
  return DxiPolarChartAnnotationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartArgumentAxisMinorTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartArgumentAxisMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartArgumentAxisMinorTickComponent,
      selectors: [["dxo-polar-chart-argument-axis-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartArgumentAxisMinorTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartArgumentAxisMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartArgumentAxisMinorTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartArgumentAxisMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartArgumentAxisMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartArgumentAxisMinorTickComponent]
    });
  }
  return DxoPolarChartArgumentAxisMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartArgumentAxisTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartArgumentAxisTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartArgumentAxisTickComponent,
      selectors: [["dxo-polar-chart-argument-axis-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartArgumentAxisTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartArgumentAxisTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartArgumentAxisTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartArgumentAxisTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartArgumentAxisTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartArgumentAxisTickComponent]
    });
  }
  return DxoPolarChartArgumentAxisTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartArgumentAxisComponent = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisComponent extends NestedOption {
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get argumentType() {
      return this._getOption('argumentType');
    }
    set argumentType(value) {
      this._setOption('argumentType', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get firstPointOnStartAngle() {
      return this._getOption('firstPointOnStartAngle');
    }
    set firstPointOnStartAngle(value) {
      this._setOption('firstPointOnStartAngle', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get originValue() {
      return this._getOption('originValue');
    }
    set originValue(value) {
      this._setOption('originValue', value);
    }
    get period() {
      return this._getOption('period');
    }
    set period(value) {
      this._setOption('period', value);
    }
    get startAngle() {
      return this._getOption('startAngle');
    }
    set startAngle(value) {
      this._setOption('startAngle', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'argumentAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartArgumentAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartArgumentAxisComponent,
      selectors: [["dxo-polar-chart-argument-axis"]],
      contentQueries: function DxoPolarChartArgumentAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        allowDecimals: "allowDecimals",
        argumentType: "argumentType",
        axisDivisionFactor: "axisDivisionFactor",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        firstPointOnStartAngle: "firstPointOnStartAngle",
        grid: "grid",
        hoverMode: "hoverMode",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        opacity: "opacity",
        originValue: "originValue",
        period: "period",
        startAngle: "startAngle",
        strips: "strips",
        stripStyle: "stripStyle",
        tick: "tick",
        tickInterval: "tickInterval",
        type: "type",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartArgumentAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartArgumentAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartArgumentAxisModule = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentAxisModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartArgumentAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartArgumentAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartArgumentAxisComponent]
    });
  }
  return DxoPolarChartArgumentAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartArgumentFormatComponent = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'argumentFormat';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartArgumentFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartArgumentFormatComponent,
      selectors: [["dxo-polar-chart-argument-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartArgumentFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartArgumentFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartArgumentFormatModule = /*#__PURE__*/(() => {
  class DxoPolarChartArgumentFormatModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartArgumentFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartArgumentFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartArgumentFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartArgumentFormatComponent]
    });
  }
  return DxoPolarChartArgumentFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartAxisLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartAxisLabelComponent extends NestedOption {
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartAxisLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAxisLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartAxisLabelComponent,
      selectors: [["dxo-polar-chart-axis-label"]],
      inputs: {
        customizeHint: "customizeHint",
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartAxisLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartAxisLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartAxisLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartAxisLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartAxisLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartAxisLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartAxisLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartAxisLabelComponent]
    });
  }
  return DxoPolarChartAxisLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartBorderComponent = /*#__PURE__*/(() => {
  class DxoPolarChartBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartBorderComponent,
      selectors: [["dxo-polar-chart-border"]],
      inputs: {
        color: "color",
        cornerRadius: "cornerRadius",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartBorderModule = /*#__PURE__*/(() => {
  class DxoPolarChartBorderModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartBorderComponent]
    });
  }
  return DxoPolarChartBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartColorComponent = /*#__PURE__*/(() => {
  class DxoPolarChartColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartColorComponent,
      selectors: [["dxo-polar-chart-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartColorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartColorModule = /*#__PURE__*/(() => {
  class DxoPolarChartColorModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartColorComponent]
    });
  }
  return DxoPolarChartColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonAnnotationSettingsComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAnnotationSettingsComponent extends NestedOption {
    renderer;
    document;
    element;
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get angle() {
      return this._getOption('angle');
    }
    set angle(value) {
      this._setOption('angle', value);
    }
    get argument() {
      return this._getOption('argument');
    }
    set argument(value) {
      this._setOption('argument', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get arrowWidth() {
      return this._getOption('arrowWidth');
    }
    set arrowWidth(value) {
      this._setOption('arrowWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get description() {
      return this._getOption('description');
    }
    set description(value) {
      this._setOption('description', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get radius() {
      return this._getOption('radius');
    }
    set radius(value) {
      this._setOption('radius', value);
    }
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get tooltipEnabled() {
      return this._getOption('tooltipEnabled');
    }
    set tooltipEnabled(value) {
      this._setOption('tooltipEnabled', value);
    }
    get tooltipTemplate() {
      return this._getOption('tooltipTemplate');
    }
    set tooltipTemplate(value) {
      this._setOption('tooltipTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'commonAnnotationSettings';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonAnnotationSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAnnotationSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonAnnotationSettingsComponent,
      selectors: [["dxo-polar-chart-common-annotation-settings"]],
      inputs: {
        allowDragging: "allowDragging",
        angle: "angle",
        argument: "argument",
        arrowLength: "arrowLength",
        arrowWidth: "arrowWidth",
        border: "border",
        color: "color",
        customizeTooltip: "customizeTooltip",
        data: "data",
        description: "description",
        font: "font",
        height: "height",
        image: "image",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        radius: "radius",
        series: "series",
        shadow: "shadow",
        template: "template",
        text: "text",
        textOverflow: "textOverflow",
        tooltipEnabled: "tooltipEnabled",
        tooltipTemplate: "tooltipTemplate",
        type: "type",
        value: "value",
        width: "width",
        wordWrap: "wordWrap",
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxoPolarChartCommonAnnotationSettingsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxoPolarChartCommonAnnotationSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonAnnotationSettingsModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAnnotationSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonAnnotationSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAnnotationSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonAnnotationSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonAnnotationSettingsComponent]
    });
  }
  return DxoPolarChartCommonAnnotationSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonAxisSettingsLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonAxisSettingsLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonAxisSettingsLabelComponent,
      selectors: [["dxo-polar-chart-common-axis-settings-label"]],
      inputs: {
        font: "font",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonAxisSettingsLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonAxisSettingsLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonAxisSettingsLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonAxisSettingsLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonAxisSettingsLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonAxisSettingsLabelComponent]
    });
  }
  return DxoPolarChartCommonAxisSettingsLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonAxisSettingsMinorTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonAxisSettingsMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonAxisSettingsMinorTickComponent,
      selectors: [["dxo-polar-chart-common-axis-settings-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonAxisSettingsMinorTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonAxisSettingsMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonAxisSettingsMinorTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonAxisSettingsMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonAxisSettingsMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonAxisSettingsMinorTickComponent]
    });
  }
  return DxoPolarChartCommonAxisSettingsMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonAxisSettingsTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonAxisSettingsTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonAxisSettingsTickComponent,
      selectors: [["dxo-polar-chart-common-axis-settings-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonAxisSettingsTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonAxisSettingsTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonAxisSettingsTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonAxisSettingsTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonAxisSettingsTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonAxisSettingsTickComponent]
    });
  }
  return DxoPolarChartCommonAxisSettingsTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonAxisSettingsComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsComponent extends NestedOption {
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'commonAxisSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonAxisSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonAxisSettingsComponent,
      selectors: [["dxo-polar-chart-common-axis-settings"]],
      inputs: {
        allowDecimals: "allowDecimals",
        color: "color",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        opacity: "opacity",
        stripStyle: "stripStyle",
        tick: "tick",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonAxisSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonAxisSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonAxisSettingsModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonAxisSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonAxisSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonAxisSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonAxisSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonAxisSettingsComponent]
    });
  }
  return DxoPolarChartCommonAxisSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonSeriesSettingsHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonSeriesSettingsHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonSeriesSettingsHoverStyleComponent,
      selectors: [["dxo-polar-chart-common-series-settings-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonSeriesSettingsHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonSeriesSettingsHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonSeriesSettingsHoverStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonSeriesSettingsHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonSeriesSettingsHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonSeriesSettingsHoverStyleComponent]
    });
  }
  return DxoPolarChartCommonSeriesSettingsHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonSeriesSettingsLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsLabelComponent extends NestedOption {
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get showForZeroValues() {
      return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value) {
      this._setOption('showForZeroValues', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonSeriesSettingsLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonSeriesSettingsLabelComponent,
      selectors: [["dxo-polar-chart-common-series-settings-label"]],
      inputs: {
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        customizeText: "customizeText",
        displayFormat: "displayFormat",
        font: "font",
        format: "format",
        position: "position",
        rotationAngle: "rotationAngle",
        showForZeroValues: "showForZeroValues",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonSeriesSettingsLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonSeriesSettingsLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonSeriesSettingsLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonSeriesSettingsLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonSeriesSettingsLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonSeriesSettingsLabelComponent]
    });
  }
  return DxoPolarChartCommonSeriesSettingsLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonSeriesSettingsSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonSeriesSettingsSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonSeriesSettingsSelectionStyleComponent,
      selectors: [["dxo-polar-chart-common-series-settings-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonSeriesSettingsSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonSeriesSettingsSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonSeriesSettingsSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonSeriesSettingsSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonSeriesSettingsSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonSeriesSettingsSelectionStyleComponent]
    });
  }
  return DxoPolarChartCommonSeriesSettingsSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartCommonSeriesSettingsComponent = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsComponent extends NestedOption {
    get area() {
      return this._getOption('area');
    }
    set area(value) {
      this._setOption('area', value);
    }
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get bar() {
      return this._getOption('bar');
    }
    set bar(value) {
      this._setOption('bar', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get closed() {
      return this._getOption('closed');
    }
    set closed(value) {
      this._setOption('closed', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get line() {
      return this._getOption('line');
    }
    set line(value) {
      this._setOption('line', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get scatter() {
      return this._getOption('scatter');
    }
    set scatter(value) {
      this._setOption('scatter', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get stackedbar() {
      return this._getOption('stackedbar');
    }
    set stackedbar(value) {
      this._setOption('stackedbar', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'commonSeriesSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartCommonSeriesSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartCommonSeriesSettingsComponent,
      selectors: [["dxo-polar-chart-common-series-settings"]],
      inputs: {
        area: "area",
        argumentField: "argumentField",
        bar: "bar",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        closed: "closed",
        color: "color",
        dashStyle: "dashStyle",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        label: "label",
        line: "line",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        opacity: "opacity",
        point: "point",
        scatter: "scatter",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        stack: "stack",
        stackedbar: "stackedbar",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartCommonSeriesSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartCommonSeriesSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartCommonSeriesSettingsModule = /*#__PURE__*/(() => {
  class DxoPolarChartCommonSeriesSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartCommonSeriesSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartCommonSeriesSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartCommonSeriesSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartCommonSeriesSettingsComponent]
    });
  }
  return DxoPolarChartCommonSeriesSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartConnectorComponent = /*#__PURE__*/(() => {
  class DxoPolarChartConnectorComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'connector';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartConnectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConnectorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartConnectorComponent,
      selectors: [["dxo-polar-chart-connector"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartConnectorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartConnectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartConnectorModule = /*#__PURE__*/(() => {
  class DxoPolarChartConnectorModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartConnectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConnectorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartConnectorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartConnectorComponent]
    });
  }
  return DxoPolarChartConnectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPolarChartConstantLineComponent = /*#__PURE__*/(() => {
  class DxiPolarChartConstantLineComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get displayBehindSeries() {
      return this._getOption('displayBehindSeries');
    }
    set displayBehindSeries(value) {
      this._setOption('displayBehindSeries', value);
    }
    get extendAxis() {
      return this._getOption('extendAxis');
    }
    set extendAxis(value) {
      this._setOption('extendAxis', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLines';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPolarChartConstantLineComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartConstantLineComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPolarChartConstantLineComponent,
      selectors: [["dxi-polar-chart-constant-line"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        displayBehindSeries: "displayBehindSeries",
        extendAxis: "extendAxis",
        label: "label",
        value: "value",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_constantLines,
        useExisting: DxiPolarChartConstantLineComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPolarChartConstantLineComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiPolarChartConstantLineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPolarChartConstantLineModule = /*#__PURE__*/(() => {
  class DxiPolarChartConstantLineModule {
    /** @nocollapse */static ɵfac = function DxiPolarChartConstantLineModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartConstantLineModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPolarChartConstantLineModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiPolarChartConstantLineComponent]
    });
  }
  return DxiPolarChartConstantLineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartConstantLineLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartConstantLineLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartConstantLineLabelComponent,
      selectors: [["dxo-polar-chart-constant-line-label"]],
      inputs: {
        font: "font",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartConstantLineLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartConstantLineLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartConstantLineLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartConstantLineLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartConstantLineLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartConstantLineLabelComponent]
    });
  }
  return DxoPolarChartConstantLineLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartConstantLineStyleLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineStyleLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartConstantLineStyleLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineStyleLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartConstantLineStyleLabelComponent,
      selectors: [["dxo-polar-chart-constant-line-style-label"]],
      inputs: {
        font: "font",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartConstantLineStyleLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartConstantLineStyleLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartConstantLineStyleLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineStyleLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartConstantLineStyleLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineStyleLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartConstantLineStyleLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartConstantLineStyleLabelComponent]
    });
  }
  return DxoPolarChartConstantLineStyleLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartConstantLineStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineStyleComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'constantLineStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartConstantLineStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartConstantLineStyleComponent,
      selectors: [["dxo-polar-chart-constant-line-style"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        label: "label",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartConstantLineStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartConstantLineStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartConstantLineStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartConstantLineStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartConstantLineStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartConstantLineStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartConstantLineStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartConstantLineStyleComponent]
    });
  }
  return DxoPolarChartConstantLineStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartDataPrepareSettingsComponent = /*#__PURE__*/(() => {
  class DxoPolarChartDataPrepareSettingsComponent extends NestedOption {
    get checkTypeForAllData() {
      return this._getOption('checkTypeForAllData');
    }
    set checkTypeForAllData(value) {
      this._setOption('checkTypeForAllData', value);
    }
    get convertToAxisDataType() {
      return this._getOption('convertToAxisDataType');
    }
    set convertToAxisDataType(value) {
      this._setOption('convertToAxisDataType', value);
    }
    get sortingMethod() {
      return this._getOption('sortingMethod');
    }
    set sortingMethod(value) {
      this._setOption('sortingMethod', value);
    }
    get _optionPath() {
      return 'dataPrepareSettings';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartDataPrepareSettingsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartDataPrepareSettingsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartDataPrepareSettingsComponent,
      selectors: [["dxo-polar-chart-data-prepare-settings"]],
      inputs: {
        checkTypeForAllData: "checkTypeForAllData",
        convertToAxisDataType: "convertToAxisDataType",
        sortingMethod: "sortingMethod"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartDataPrepareSettingsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartDataPrepareSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartDataPrepareSettingsModule = /*#__PURE__*/(() => {
  class DxoPolarChartDataPrepareSettingsModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartDataPrepareSettingsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartDataPrepareSettingsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartDataPrepareSettingsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartDataPrepareSettingsComponent]
    });
  }
  return DxoPolarChartDataPrepareSettingsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartExportComponent = /*#__PURE__*/(() => {
  class DxoPolarChartExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartExportComponent,
      selectors: [["dxo-polar-chart-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartExportComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartExportModule = /*#__PURE__*/(() => {
  class DxoPolarChartExportModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartExportComponent]
    });
  }
  return DxoPolarChartExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartFontComponent = /*#__PURE__*/(() => {
  class DxoPolarChartFontComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartFontComponent,
      selectors: [["dxo-polar-chart-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartFontComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartFontModule = /*#__PURE__*/(() => {
  class DxoPolarChartFontModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartFontComponent]
    });
  }
  return DxoPolarChartFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartFormatComponent = /*#__PURE__*/(() => {
  class DxoPolarChartFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartFormatComponent,
      selectors: [["dxo-polar-chart-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartFormatComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartFormatModule = /*#__PURE__*/(() => {
  class DxoPolarChartFormatModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartFormatComponent]
    });
  }
  return DxoPolarChartFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartGridComponent = /*#__PURE__*/(() => {
  class DxoPolarChartGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'grid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartGridComponent,
      selectors: [["dxo-polar-chart-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartGridModule = /*#__PURE__*/(() => {
  class DxoPolarChartGridModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartGridComponent]
    });
  }
  return DxoPolarChartGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartHatchingComponent = /*#__PURE__*/(() => {
  class DxoPolarChartHatchingComponent extends NestedOption {
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get step() {
      return this._getOption('step');
    }
    set step(value) {
      this._setOption('step', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'hatching';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartHatchingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartHatchingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartHatchingComponent,
      selectors: [["dxo-polar-chart-hatching"]],
      inputs: {
        direction: "direction",
        opacity: "opacity",
        step: "step",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartHatchingComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartHatchingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartHatchingModule = /*#__PURE__*/(() => {
  class DxoPolarChartHatchingModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartHatchingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartHatchingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartHatchingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartHatchingComponent]
    });
  }
  return DxoPolarChartHatchingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartHoverStyleComponent,
      selectors: [["dxo-polar-chart-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartHoverStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartHoverStyleComponent]
    });
  }
  return DxoPolarChartHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartImageComponent = /*#__PURE__*/(() => {
  class DxoPolarChartImageComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get url() {
      return this._getOption('url');
    }
    set url(value) {
      this._setOption('url', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'image';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartImageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartImageComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartImageComponent,
      selectors: [["dxo-polar-chart-image"]],
      inputs: {
        height: "height",
        url: "url",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartImageComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartImageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartImageModule = /*#__PURE__*/(() => {
  class DxoPolarChartImageModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartImageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartImageModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartImageModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartImageComponent]
    });
  }
  return DxoPolarChartImageModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indentFromAxis() {
      return this._getOption('indentFromAxis');
    }
    set indentFromAxis(value) {
      this._setOption('indentFromAxis', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get connector() {
      return this._getOption('connector');
    }
    set connector(value) {
      this._setOption('connector', value);
    }
    get displayFormat() {
      return this._getOption('displayFormat');
    }
    set displayFormat(value) {
      this._setOption('displayFormat', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get rotationAngle() {
      return this._getOption('rotationAngle');
    }
    set rotationAngle(value) {
      this._setOption('rotationAngle', value);
    }
    get showForZeroValues() {
      return this._getOption('showForZeroValues');
    }
    set showForZeroValues(value) {
      this._setOption('showForZeroValues', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLabelComponent,
      selectors: [["dxo-polar-chart-label"]],
      inputs: {
        font: "font",
        text: "text",
        visible: "visible",
        customizeHint: "customizeHint",
        customizeText: "customizeText",
        format: "format",
        indentFromAxis: "indentFromAxis",
        overlappingBehavior: "overlappingBehavior",
        argumentFormat: "argumentFormat",
        backgroundColor: "backgroundColor",
        border: "border",
        connector: "connector",
        displayFormat: "displayFormat",
        position: "position",
        rotationAngle: "rotationAngle",
        showForZeroValues: "showForZeroValues"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLabelComponent]
    });
  }
  return DxoPolarChartLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLegendTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLegendTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLegendTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLegendTitleSubtitleComponent,
      selectors: [["dxo-polar-chart-legend-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLegendTitleSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLegendTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLegendTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartLegendTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLegendTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLegendTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLegendTitleSubtitleComponent]
    });
  }
  return DxoPolarChartLegendTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLegendTitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLegendTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLegendTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLegendTitleComponent,
      selectors: [["dxo-polar-chart-legend-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLegendTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLegendTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLegendTitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartLegendTitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLegendTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLegendTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLegendTitleComponent]
    });
  }
  return DxoPolarChartLegendTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLegendComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLegendComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get columnCount() {
      return this._getOption('columnCount');
    }
    set columnCount(value) {
      this._setOption('columnCount', value);
    }
    get columnItemSpacing() {
      return this._getOption('columnItemSpacing');
    }
    set columnItemSpacing(value) {
      this._setOption('columnItemSpacing', value);
    }
    get customizeHint() {
      return this._getOption('customizeHint');
    }
    set customizeHint(value) {
      this._setOption('customizeHint', value);
    }
    get customizeItems() {
      return this._getOption('customizeItems');
    }
    set customizeItems(value) {
      this._setOption('customizeItems', value);
    }
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get itemsAlignment() {
      return this._getOption('itemsAlignment');
    }
    set itemsAlignment(value) {
      this._setOption('itemsAlignment', value);
    }
    get itemTextPosition() {
      return this._getOption('itemTextPosition');
    }
    set itemTextPosition(value) {
      this._setOption('itemTextPosition', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get markerSize() {
      return this._getOption('markerSize');
    }
    set markerSize(value) {
      this._setOption('markerSize', value);
    }
    get markerTemplate() {
      return this._getOption('markerTemplate');
    }
    set markerTemplate(value) {
      this._setOption('markerTemplate', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get rowCount() {
      return this._getOption('rowCount');
    }
    set rowCount(value) {
      this._setOption('rowCount', value);
    }
    get rowItemSpacing() {
      return this._getOption('rowItemSpacing');
    }
    set rowItemSpacing(value) {
      this._setOption('rowItemSpacing', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'legend';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLegendComponent,
      selectors: [["dxo-polar-chart-legend"]],
      inputs: {
        backgroundColor: "backgroundColor",
        border: "border",
        columnCount: "columnCount",
        columnItemSpacing: "columnItemSpacing",
        customizeHint: "customizeHint",
        customizeItems: "customizeItems",
        customizeText: "customizeText",
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        hoverMode: "hoverMode",
        itemsAlignment: "itemsAlignment",
        itemTextPosition: "itemTextPosition",
        margin: "margin",
        markerSize: "markerSize",
        markerTemplate: "markerTemplate",
        orientation: "orientation",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        rowCount: "rowCount",
        rowItemSpacing: "rowItemSpacing",
        title: "title",
        verticalAlignment: "verticalAlignment",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLegendComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLegendComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLegendModule = /*#__PURE__*/(() => {
  class DxoPolarChartLegendModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLegendModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLegendModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLegendModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLegendComponent]
    });
  }
  return DxoPolarChartLegendModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLengthComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLengthComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'length';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLengthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLengthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLengthComponent,
      selectors: [["dxo-polar-chart-length"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLengthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLengthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLengthModule = /*#__PURE__*/(() => {
  class DxoPolarChartLengthModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLengthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLengthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLengthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLengthComponent]
    });
  }
  return DxoPolarChartLengthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoPolarChartLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartLoadingIndicatorComponent,
      selectors: [["dxo-polar-chart-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        font: "font",
        show: "show",
        text: "text"
      },
      outputs: {
        showChange: "showChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartLoadingIndicatorComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoPolarChartLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartLoadingIndicatorComponent]
    });
  }
  return DxoPolarChartLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartMarginComponent = /*#__PURE__*/(() => {
  class DxoPolarChartMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartMarginComponent,
      selectors: [["dxo-polar-chart-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartMarginComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartMarginModule = /*#__PURE__*/(() => {
  class DxoPolarChartMarginModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartMarginComponent]
    });
  }
  return DxoPolarChartMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartMinVisualRangeLengthComponent = /*#__PURE__*/(() => {
  class DxoPolarChartMinVisualRangeLengthComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minVisualRangeLength';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartMinVisualRangeLengthComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinVisualRangeLengthComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartMinVisualRangeLengthComponent,
      selectors: [["dxo-polar-chart-min-visual-range-length"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartMinVisualRangeLengthComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartMinVisualRangeLengthComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartMinVisualRangeLengthModule = /*#__PURE__*/(() => {
  class DxoPolarChartMinVisualRangeLengthModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartMinVisualRangeLengthModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinVisualRangeLengthModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartMinVisualRangeLengthModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartMinVisualRangeLengthComponent]
    });
  }
  return DxoPolarChartMinVisualRangeLengthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartMinorGridComponent = /*#__PURE__*/(() => {
  class DxoPolarChartMinorGridComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorGrid';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartMinorGridComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorGridComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartMinorGridComponent,
      selectors: [["dxo-polar-chart-minor-grid"]],
      inputs: {
        color: "color",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartMinorGridComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartMinorGridComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartMinorGridModule = /*#__PURE__*/(() => {
  class DxoPolarChartMinorGridModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartMinorGridModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorGridModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartMinorGridModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartMinorGridComponent]
    });
  }
  return DxoPolarChartMinorGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartMinorTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoPolarChartMinorTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'minorTickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartMinorTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartMinorTickIntervalComponent,
      selectors: [["dxo-polar-chart-minor-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartMinorTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartMinorTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartMinorTickIntervalModule = /*#__PURE__*/(() => {
  class DxoPolarChartMinorTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartMinorTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartMinorTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartMinorTickIntervalComponent]
    });
  }
  return DxoPolarChartMinorTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartMinorTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartMinorTickComponent,
      selectors: [["dxo-polar-chart-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartMinorTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartMinorTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartMinorTickComponent]
    });
  }
  return DxoPolarChartMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPointBorderComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPointBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPointBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPointBorderComponent,
      selectors: [["dxo-polar-chart-point-border"]],
      inputs: {
        color: "color",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPointBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPointBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPointBorderModule = /*#__PURE__*/(() => {
  class DxoPolarChartPointBorderModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPointBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPointBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPointBorderComponent]
    });
  }
  return DxoPolarChartPointBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPointHoverStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPointHoverStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'hoverStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPointHoverStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointHoverStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPointHoverStyleComponent,
      selectors: [["dxo-polar-chart-point-hover-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPointHoverStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPointHoverStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPointHoverStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartPointHoverStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPointHoverStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointHoverStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPointHoverStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPointHoverStyleComponent]
    });
  }
  return DxoPolarChartPointHoverStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPointSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPointSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPointSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPointSelectionStyleComponent,
      selectors: [["dxo-polar-chart-point-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPointSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPointSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPointSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartPointSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPointSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPointSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPointSelectionStyleComponent]
    });
  }
  return DxoPolarChartPointSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPointComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPointComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get image() {
      return this._getOption('image');
    }
    set image(value) {
      this._setOption('image', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get symbol() {
      return this._getOption('symbol');
    }
    set symbol(value) {
      this._setOption('symbol', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'point';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPointComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPointComponent,
      selectors: [["dxo-polar-chart-point"]],
      inputs: {
        border: "border",
        color: "color",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        image: "image",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        size: "size",
        symbol: "symbol",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPointComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPointComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPointModule = /*#__PURE__*/(() => {
  class DxoPolarChartPointModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPointModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPointModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPointModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPointComponent]
    });
  }
  return DxoPolarChartPointModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPolarChartTitleSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPolarChartTitleSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPolarChartTitleSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPolarChartTitleSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPolarChartTitleSubtitleComponent,
      selectors: [["dxo-polar-chart-polar-chart-title-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPolarChartTitleSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPolarChartTitleSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPolarChartTitleSubtitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartPolarChartTitleSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPolarChartTitleSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPolarChartTitleSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPolarChartTitleSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPolarChartTitleSubtitleComponent]
    });
  }
  return DxoPolarChartPolarChartTitleSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartPolarChartTitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartPolarChartTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartPolarChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPolarChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartPolarChartTitleComponent,
      selectors: [["dxo-polar-chart-polar-chart-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        textOverflow: "textOverflow",
        verticalAlignment: "verticalAlignment",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartPolarChartTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartPolarChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartPolarChartTitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartPolarChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartPolarChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartPolarChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartPolarChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartPolarChartTitleComponent]
    });
  }
  return DxoPolarChartPolarChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartSelectionStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartSelectionStyleComponent extends NestedOption {
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hatching() {
      return this._getOption('hatching');
    }
    set hatching(value) {
      this._setOption('hatching', value);
    }
    get highlight() {
      return this._getOption('highlight');
    }
    set highlight(value) {
      this._setOption('highlight', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'selectionStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartSelectionStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSelectionStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartSelectionStyleComponent,
      selectors: [["dxo-polar-chart-selection-style"]],
      inputs: {
        border: "border",
        color: "color",
        size: "size",
        dashStyle: "dashStyle",
        hatching: "hatching",
        highlight: "highlight",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartSelectionStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartSelectionStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartSelectionStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartSelectionStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartSelectionStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSelectionStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartSelectionStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartSelectionStyleComponent]
    });
  }
  return DxoPolarChartSelectionStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartSeriesBorderComponent = /*#__PURE__*/(() => {
  class DxoPolarChartSeriesBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartSeriesBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSeriesBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartSeriesBorderComponent,
      selectors: [["dxo-polar-chart-series-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartSeriesBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartSeriesBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartSeriesBorderModule = /*#__PURE__*/(() => {
  class DxoPolarChartSeriesBorderModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartSeriesBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSeriesBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartSeriesBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartSeriesBorderComponent]
    });
  }
  return DxoPolarChartSeriesBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPolarChartSeriesComponent = /*#__PURE__*/(() => {
  class DxiPolarChartSeriesComponent extends CollectionNestedOption {
    get argumentField() {
      return this._getOption('argumentField');
    }
    set argumentField(value) {
      this._setOption('argumentField', value);
    }
    get barPadding() {
      return this._getOption('barPadding');
    }
    set barPadding(value) {
      this._setOption('barPadding', value);
    }
    get barWidth() {
      return this._getOption('barWidth');
    }
    set barWidth(value) {
      this._setOption('barWidth', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get closed() {
      return this._getOption('closed');
    }
    set closed(value) {
      this._setOption('closed', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get hoverMode() {
      return this._getOption('hoverMode');
    }
    set hoverMode(value) {
      this._setOption('hoverMode', value);
    }
    get hoverStyle() {
      return this._getOption('hoverStyle');
    }
    set hoverStyle(value) {
      this._setOption('hoverStyle', value);
    }
    get ignoreEmptyPoints() {
      return this._getOption('ignoreEmptyPoints');
    }
    set ignoreEmptyPoints(value) {
      this._setOption('ignoreEmptyPoints', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get maxLabelCount() {
      return this._getOption('maxLabelCount');
    }
    set maxLabelCount(value) {
      this._setOption('maxLabelCount', value);
    }
    get minBarSize() {
      return this._getOption('minBarSize');
    }
    set minBarSize(value) {
      this._setOption('minBarSize', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get point() {
      return this._getOption('point');
    }
    set point(value) {
      this._setOption('point', value);
    }
    get selectionMode() {
      return this._getOption('selectionMode');
    }
    set selectionMode(value) {
      this._setOption('selectionMode', value);
    }
    get selectionStyle() {
      return this._getOption('selectionStyle');
    }
    set selectionStyle(value) {
      this._setOption('selectionStyle', value);
    }
    get showInLegend() {
      return this._getOption('showInLegend');
    }
    set showInLegend(value) {
      this._setOption('showInLegend', value);
    }
    get stack() {
      return this._getOption('stack');
    }
    set stack(value) {
      this._setOption('stack', value);
    }
    get tag() {
      return this._getOption('tag');
    }
    set tag(value) {
      this._setOption('tag', value);
    }
    get tagField() {
      return this._getOption('tagField');
    }
    set tagField(value) {
      this._setOption('tagField', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueErrorBar() {
      return this._getOption('valueErrorBar');
    }
    set valueErrorBar(value) {
      this._setOption('valueErrorBar', value);
    }
    get valueField() {
      return this._getOption('valueField');
    }
    set valueField(value) {
      this._setOption('valueField', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'series';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPolarChartSeriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartSeriesComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPolarChartSeriesComponent,
      selectors: [["dxi-polar-chart-series"]],
      inputs: {
        argumentField: "argumentField",
        barPadding: "barPadding",
        barWidth: "barWidth",
        border: "border",
        closed: "closed",
        color: "color",
        dashStyle: "dashStyle",
        hoverMode: "hoverMode",
        hoverStyle: "hoverStyle",
        ignoreEmptyPoints: "ignoreEmptyPoints",
        label: "label",
        maxLabelCount: "maxLabelCount",
        minBarSize: "minBarSize",
        name: "name",
        opacity: "opacity",
        point: "point",
        selectionMode: "selectionMode",
        selectionStyle: "selectionStyle",
        showInLegend: "showInLegend",
        stack: "stack",
        tag: "tag",
        tagField: "tagField",
        type: "type",
        valueErrorBar: "valueErrorBar",
        valueField: "valueField",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_series,
        useExisting: DxiPolarChartSeriesComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPolarChartSeriesComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiPolarChartSeriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPolarChartSeriesModule = /*#__PURE__*/(() => {
  class DxiPolarChartSeriesModule {
    /** @nocollapse */static ɵfac = function DxiPolarChartSeriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartSeriesModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPolarChartSeriesModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiPolarChartSeriesComponent]
    });
  }
  return DxiPolarChartSeriesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartSeriesTemplateComponent = /*#__PURE__*/(() => {
  class DxoPolarChartSeriesTemplateComponent extends NestedOption {
    get customizeSeries() {
      return this._getOption('customizeSeries');
    }
    set customizeSeries(value) {
      this._setOption('customizeSeries', value);
    }
    get nameField() {
      return this._getOption('nameField');
    }
    set nameField(value) {
      this._setOption('nameField', value);
    }
    get _optionPath() {
      return 'seriesTemplate';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartSeriesTemplateComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSeriesTemplateComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartSeriesTemplateComponent,
      selectors: [["dxo-polar-chart-series-template"]],
      inputs: {
        customizeSeries: "customizeSeries",
        nameField: "nameField"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartSeriesTemplateComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartSeriesTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartSeriesTemplateModule = /*#__PURE__*/(() => {
  class DxoPolarChartSeriesTemplateModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartSeriesTemplateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSeriesTemplateModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartSeriesTemplateModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartSeriesTemplateComponent]
    });
  }
  return DxoPolarChartSeriesTemplateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartShadowComponent = /*#__PURE__*/(() => {
  class DxoPolarChartShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartShadowComponent,
      selectors: [["dxo-polar-chart-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartShadowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartShadowModule = /*#__PURE__*/(() => {
  class DxoPolarChartShadowModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartShadowComponent]
    });
  }
  return DxoPolarChartShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartSizeComponent = /*#__PURE__*/(() => {
  class DxoPolarChartSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartSizeComponent,
      selectors: [["dxo-polar-chart-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartSizeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartSizeModule = /*#__PURE__*/(() => {
  class DxoPolarChartSizeModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartSizeComponent]
    });
  }
  return DxoPolarChartSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiPolarChartStripComponent = /*#__PURE__*/(() => {
  class DxiPolarChartStripComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'strips';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiPolarChartStripComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartStripComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiPolarChartStripComponent,
      selectors: [["dxi-polar-chart-strip"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        label: "label",
        startValue: "startValue"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_strips,
        useExisting: DxiPolarChartStripComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiPolarChartStripComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiPolarChartStripComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiPolarChartStripModule = /*#__PURE__*/(() => {
  class DxiPolarChartStripModule {
    /** @nocollapse */static ɵfac = function DxiPolarChartStripModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiPolarChartStripModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiPolarChartStripModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiPolarChartStripComponent]
    });
  }
  return DxiPolarChartStripModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartStripLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartStripLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartStripLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartStripLabelComponent,
      selectors: [["dxo-polar-chart-strip-label"]],
      inputs: {
        font: "font",
        text: "text"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartStripLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartStripLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartStripLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartStripLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartStripLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartStripLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartStripLabelComponent]
    });
  }
  return DxoPolarChartStripLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartStripStyleLabelComponent = /*#__PURE__*/(() => {
  class DxoPolarChartStripStyleLabelComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartStripStyleLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripStyleLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartStripStyleLabelComponent,
      selectors: [["dxo-polar-chart-strip-style-label"]],
      inputs: {
        font: "font"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartStripStyleLabelComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartStripStyleLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartStripStyleLabelModule = /*#__PURE__*/(() => {
  class DxoPolarChartStripStyleLabelModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartStripStyleLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripStyleLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartStripStyleLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartStripStyleLabelComponent]
    });
  }
  return DxoPolarChartStripStyleLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartStripStyleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartStripStyleComponent extends NestedOption {
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get _optionPath() {
      return 'stripStyle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartStripStyleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripStyleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartStripStyleComponent,
      selectors: [["dxo-polar-chart-strip-style"]],
      inputs: {
        label: "label"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartStripStyleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartStripStyleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartStripStyleModule = /*#__PURE__*/(() => {
  class DxoPolarChartStripStyleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartStripStyleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartStripStyleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartStripStyleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartStripStyleComponent]
    });
  }
  return DxoPolarChartStripStyleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartSubtitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartSubtitleComponent,
      selectors: [["dxo-polar-chart-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartSubtitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartSubtitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartSubtitleComponent]
    });
  }
  return DxoPolarChartSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartTickIntervalComponent = /*#__PURE__*/(() => {
  class DxoPolarChartTickIntervalComponent extends NestedOption {
    get days() {
      return this._getOption('days');
    }
    set days(value) {
      this._setOption('days', value);
    }
    get hours() {
      return this._getOption('hours');
    }
    set hours(value) {
      this._setOption('hours', value);
    }
    get milliseconds() {
      return this._getOption('milliseconds');
    }
    set milliseconds(value) {
      this._setOption('milliseconds', value);
    }
    get minutes() {
      return this._getOption('minutes');
    }
    set minutes(value) {
      this._setOption('minutes', value);
    }
    get months() {
      return this._getOption('months');
    }
    set months(value) {
      this._setOption('months', value);
    }
    get quarters() {
      return this._getOption('quarters');
    }
    set quarters(value) {
      this._setOption('quarters', value);
    }
    get seconds() {
      return this._getOption('seconds');
    }
    set seconds(value) {
      this._setOption('seconds', value);
    }
    get weeks() {
      return this._getOption('weeks');
    }
    set weeks(value) {
      this._setOption('weeks', value);
    }
    get years() {
      return this._getOption('years');
    }
    set years(value) {
      this._setOption('years', value);
    }
    get _optionPath() {
      return 'tickInterval';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartTickIntervalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTickIntervalComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartTickIntervalComponent,
      selectors: [["dxo-polar-chart-tick-interval"]],
      inputs: {
        days: "days",
        hours: "hours",
        milliseconds: "milliseconds",
        minutes: "minutes",
        months: "months",
        quarters: "quarters",
        seconds: "seconds",
        weeks: "weeks",
        years: "years"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartTickIntervalComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartTickIntervalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartTickIntervalModule = /*#__PURE__*/(() => {
  class DxoPolarChartTickIntervalModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartTickIntervalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTickIntervalModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartTickIntervalModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartTickIntervalComponent]
    });
  }
  return DxoPolarChartTickIntervalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartTickComponent = /*#__PURE__*/(() => {
  class DxoPolarChartTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get shift() {
      return this._getOption('shift');
    }
    set shift(value) {
      this._setOption('shift', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartTickComponent,
      selectors: [["dxo-polar-chart-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        shift: "shift",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartTickComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartTickModule = /*#__PURE__*/(() => {
  class DxoPolarChartTickModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartTickComponent]
    });
  }
  return DxoPolarChartTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartTitleComponent = /*#__PURE__*/(() => {
  class DxoPolarChartTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartTitleComponent,
      selectors: [["dxo-polar-chart-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        verticalAlignment: "verticalAlignment",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartTitleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartTitleModule = /*#__PURE__*/(() => {
  class DxoPolarChartTitleModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartTitleComponent]
    });
  }
  return DxoPolarChartTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartTooltipBorderComponent = /*#__PURE__*/(() => {
  class DxoPolarChartTooltipBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartTooltipBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTooltipBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartTooltipBorderComponent,
      selectors: [["dxo-polar-chart-tooltip-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartTooltipBorderComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartTooltipBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartTooltipBorderModule = /*#__PURE__*/(() => {
  class DxoPolarChartTooltipBorderModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartTooltipBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTooltipBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartTooltipBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartTooltipBorderComponent]
    });
  }
  return DxoPolarChartTooltipBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartTooltipComponent = /*#__PURE__*/(() => {
  class DxoPolarChartTooltipComponent extends NestedOption {
    get argumentFormat() {
      return this._getOption('argumentFormat');
    }
    set argumentFormat(value) {
      this._setOption('argumentFormat', value);
    }
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get shared() {
      return this._getOption('shared');
    }
    set shared(value) {
      this._setOption('shared', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartTooltipComponent,
      selectors: [["dxo-polar-chart-tooltip"]],
      inputs: {
        argumentFormat: "argumentFormat",
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        shared: "shared",
        zIndex: "zIndex"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartTooltipComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartTooltipModule = /*#__PURE__*/(() => {
  class DxoPolarChartTooltipModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartTooltipComponent]
    });
  }
  return DxoPolarChartTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartValueAxisComponent = /*#__PURE__*/(() => {
  class DxoPolarChartValueAxisComponent extends NestedOption {
    set _constantLinesContentChildren(value) {
      this.setChildren('constantLines', value);
    }
    set _stripsContentChildren(value) {
      this.setChildren('strips', value);
    }
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get axisDivisionFactor() {
      return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value) {
      this._setOption('axisDivisionFactor', value);
    }
    get categories() {
      return this._getOption('categories');
    }
    set categories(value) {
      this._setOption('categories', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get constantLines() {
      return this._getOption('constantLines');
    }
    set constantLines(value) {
      this._setOption('constantLines', value);
    }
    get constantLineStyle() {
      return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value) {
      this._setOption('constantLineStyle', value);
    }
    get discreteAxisDivisionMode() {
      return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value) {
      this._setOption('discreteAxisDivisionMode', value);
    }
    get endOnTick() {
      return this._getOption('endOnTick');
    }
    set endOnTick(value) {
      this._setOption('endOnTick', value);
    }
    get grid() {
      return this._getOption('grid');
    }
    set grid(value) {
      this._setOption('grid', value);
    }
    get inverted() {
      return this._getOption('inverted');
    }
    set inverted(value) {
      this._setOption('inverted', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get linearThreshold() {
      return this._getOption('linearThreshold');
    }
    set linearThreshold(value) {
      this._setOption('linearThreshold', value);
    }
    get logarithmBase() {
      return this._getOption('logarithmBase');
    }
    set logarithmBase(value) {
      this._setOption('logarithmBase', value);
    }
    get maxValueMargin() {
      return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value) {
      this._setOption('maxValueMargin', value);
    }
    get minorGrid() {
      return this._getOption('minorGrid');
    }
    set minorGrid(value) {
      this._setOption('minorGrid', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickCount() {
      return this._getOption('minorTickCount');
    }
    set minorTickCount(value) {
      this._setOption('minorTickCount', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get minValueMargin() {
      return this._getOption('minValueMargin');
    }
    set minValueMargin(value) {
      this._setOption('minValueMargin', value);
    }
    get minVisualRangeLength() {
      return this._getOption('minVisualRangeLength');
    }
    set minVisualRangeLength(value) {
      this._setOption('minVisualRangeLength', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get showZero() {
      return this._getOption('showZero');
    }
    set showZero(value) {
      this._setOption('showZero', value);
    }
    get strips() {
      return this._getOption('strips');
    }
    set strips(value) {
      this._setOption('strips', value);
    }
    get stripStyle() {
      return this._getOption('stripStyle');
    }
    set stripStyle(value) {
      this._setOption('stripStyle', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get valueMarginsEnabled() {
      return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value) {
      this._setOption('valueMarginsEnabled', value);
    }
    get valueType() {
      return this._getOption('valueType');
    }
    set valueType(value) {
      this._setOption('valueType', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get visualRange() {
      return this._getOption('visualRange');
    }
    set visualRange(value) {
      this._setOption('visualRange', value);
    }
    get visualRangeUpdateMode() {
      return this._getOption('visualRangeUpdateMode');
    }
    set visualRangeUpdateMode(value) {
      this._setOption('visualRangeUpdateMode', value);
    }
    get wholeRange() {
      return this._getOption('wholeRange');
    }
    set wholeRange(value) {
      this._setOption('wholeRange', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visualRangeChange;
    get _optionPath() {
      return 'valueAxis';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'visualRangeChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartValueAxisComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartValueAxisComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartValueAxisComponent,
      selectors: [["dxo-polar-chart-value-axis"]],
      contentQueries: function DxoPolarChartValueAxisComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_constantLines, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_strips, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._constantLinesContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._stripsContentChildren = _t);
        }
      },
      inputs: {
        allowDecimals: "allowDecimals",
        axisDivisionFactor: "axisDivisionFactor",
        categories: "categories",
        color: "color",
        constantLines: "constantLines",
        constantLineStyle: "constantLineStyle",
        discreteAxisDivisionMode: "discreteAxisDivisionMode",
        endOnTick: "endOnTick",
        grid: "grid",
        inverted: "inverted",
        label: "label",
        linearThreshold: "linearThreshold",
        logarithmBase: "logarithmBase",
        maxValueMargin: "maxValueMargin",
        minorGrid: "minorGrid",
        minorTick: "minorTick",
        minorTickCount: "minorTickCount",
        minorTickInterval: "minorTickInterval",
        minValueMargin: "minValueMargin",
        minVisualRangeLength: "minVisualRangeLength",
        opacity: "opacity",
        showZero: "showZero",
        strips: "strips",
        stripStyle: "stripStyle",
        tick: "tick",
        tickInterval: "tickInterval",
        type: "type",
        valueMarginsEnabled: "valueMarginsEnabled",
        valueType: "valueType",
        visible: "visible",
        visualRange: "visualRange",
        visualRangeUpdateMode: "visualRangeUpdateMode",
        wholeRange: "wholeRange",
        width: "width"
      },
      outputs: {
        visualRangeChange: "visualRangeChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartValueAxisComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartValueAxisComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartValueAxisModule = /*#__PURE__*/(() => {
  class DxoPolarChartValueAxisModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartValueAxisModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartValueAxisModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartValueAxisModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartValueAxisComponent]
    });
  }
  return DxoPolarChartValueAxisModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartValueErrorBarComponent = /*#__PURE__*/(() => {
  class DxoPolarChartValueErrorBarComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get displayMode() {
      return this._getOption('displayMode');
    }
    set displayMode(value) {
      this._setOption('displayMode', value);
    }
    get edgeLength() {
      return this._getOption('edgeLength');
    }
    set edgeLength(value) {
      this._setOption('edgeLength', value);
    }
    get highValueField() {
      return this._getOption('highValueField');
    }
    set highValueField(value) {
      this._setOption('highValueField', value);
    }
    get lineWidth() {
      return this._getOption('lineWidth');
    }
    set lineWidth(value) {
      this._setOption('lineWidth', value);
    }
    get lowValueField() {
      return this._getOption('lowValueField');
    }
    set lowValueField(value) {
      this._setOption('lowValueField', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get value() {
      return this._getOption('value');
    }
    set value(value) {
      this._setOption('value', value);
    }
    get _optionPath() {
      return 'valueErrorBar';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartValueErrorBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartValueErrorBarComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartValueErrorBarComponent,
      selectors: [["dxo-polar-chart-value-error-bar"]],
      inputs: {
        color: "color",
        displayMode: "displayMode",
        edgeLength: "edgeLength",
        highValueField: "highValueField",
        lineWidth: "lineWidth",
        lowValueField: "lowValueField",
        opacity: "opacity",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartValueErrorBarComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartValueErrorBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartValueErrorBarModule = /*#__PURE__*/(() => {
  class DxoPolarChartValueErrorBarModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartValueErrorBarModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartValueErrorBarModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartValueErrorBarModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartValueErrorBarComponent]
    });
  }
  return DxoPolarChartValueErrorBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartVisualRangeComponent = /*#__PURE__*/(() => {
  class DxoPolarChartVisualRangeComponent extends NestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    endValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    startValueChange;
    get _optionPath() {
      return 'visualRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'endValueChange'
      }, {
        emit: 'startValueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartVisualRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartVisualRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartVisualRangeComponent,
      selectors: [["dxo-polar-chart-visual-range"]],
      inputs: {
        endValue: "endValue",
        length: "length",
        startValue: "startValue"
      },
      outputs: {
        endValueChange: "endValueChange",
        startValueChange: "startValueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartVisualRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartVisualRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartVisualRangeModule = /*#__PURE__*/(() => {
  class DxoPolarChartVisualRangeModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartVisualRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartVisualRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartVisualRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartVisualRangeComponent]
    });
  }
  return DxoPolarChartVisualRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoPolarChartWholeRangeComponent = /*#__PURE__*/(() => {
  class DxoPolarChartWholeRangeComponent extends NestedOption {
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    endValueChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    startValueChange;
    get _optionPath() {
      return 'wholeRange';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'endValueChange'
      }, {
        emit: 'startValueChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoPolarChartWholeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartWholeRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoPolarChartWholeRangeComponent,
      selectors: [["dxo-polar-chart-whole-range"]],
      inputs: {
        endValue: "endValue",
        length: "length",
        startValue: "startValue"
      },
      outputs: {
        endValueChange: "endValueChange",
        startValueChange: "startValueChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoPolarChartWholeRangeComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoPolarChartWholeRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoPolarChartWholeRangeModule = /*#__PURE__*/(() => {
  class DxoPolarChartWholeRangeModule {
    /** @nocollapse */static ɵfac = function DxoPolarChartWholeRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoPolarChartWholeRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoPolarChartWholeRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoPolarChartWholeRangeComponent]
    });
  }
  return DxoPolarChartWholeRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiPolarChartAnnotationComponent, DxiPolarChartAnnotationModule, DxiPolarChartConstantLineComponent, DxiPolarChartConstantLineModule, DxiPolarChartSeriesComponent, DxiPolarChartSeriesModule, DxiPolarChartStripComponent, DxiPolarChartStripModule, DxoPolarChartAdaptiveLayoutComponent, DxoPolarChartAdaptiveLayoutModule, DxoPolarChartAnimationComponent, DxoPolarChartAnimationModule, DxoPolarChartAnnotationBorderComponent, DxoPolarChartAnnotationBorderModule, DxoPolarChartArgumentAxisComponent, DxoPolarChartArgumentAxisMinorTickComponent, DxoPolarChartArgumentAxisMinorTickModule, DxoPolarChartArgumentAxisModule, DxoPolarChartArgumentAxisTickComponent, DxoPolarChartArgumentAxisTickModule, DxoPolarChartArgumentFormatComponent, DxoPolarChartArgumentFormatModule, DxoPolarChartAxisLabelComponent, DxoPolarChartAxisLabelModule, DxoPolarChartBorderComponent, DxoPolarChartBorderModule, DxoPolarChartColorComponent, DxoPolarChartColorModule, DxoPolarChartCommonAnnotationSettingsComponent, DxoPolarChartCommonAnnotationSettingsModule, DxoPolarChartCommonAxisSettingsComponent, DxoPolarChartCommonAxisSettingsLabelComponent, DxoPolarChartCommonAxisSettingsLabelModule, DxoPolarChartCommonAxisSettingsMinorTickComponent, DxoPolarChartCommonAxisSettingsMinorTickModule, DxoPolarChartCommonAxisSettingsModule, DxoPolarChartCommonAxisSettingsTickComponent, DxoPolarChartCommonAxisSettingsTickModule, DxoPolarChartCommonSeriesSettingsComponent, DxoPolarChartCommonSeriesSettingsHoverStyleComponent, DxoPolarChartCommonSeriesSettingsHoverStyleModule, DxoPolarChartCommonSeriesSettingsLabelComponent, DxoPolarChartCommonSeriesSettingsLabelModule, DxoPolarChartCommonSeriesSettingsModule, DxoPolarChartCommonSeriesSettingsSelectionStyleComponent, DxoPolarChartCommonSeriesSettingsSelectionStyleModule, DxoPolarChartConnectorComponent, DxoPolarChartConnectorModule, DxoPolarChartConstantLineLabelComponent, DxoPolarChartConstantLineLabelModule, DxoPolarChartConstantLineStyleComponent, DxoPolarChartConstantLineStyleLabelComponent, DxoPolarChartConstantLineStyleLabelModule, DxoPolarChartConstantLineStyleModule, DxoPolarChartDataPrepareSettingsComponent, DxoPolarChartDataPrepareSettingsModule, DxoPolarChartExportComponent, DxoPolarChartExportModule, DxoPolarChartFontComponent, DxoPolarChartFontModule, DxoPolarChartFormatComponent, DxoPolarChartFormatModule, DxoPolarChartGridComponent, DxoPolarChartGridModule, DxoPolarChartHatchingComponent, DxoPolarChartHatchingModule, DxoPolarChartHoverStyleComponent, DxoPolarChartHoverStyleModule, DxoPolarChartImageComponent, DxoPolarChartImageModule, DxoPolarChartLabelComponent, DxoPolarChartLabelModule, DxoPolarChartLegendComponent, DxoPolarChartLegendModule, DxoPolarChartLegendTitleComponent, DxoPolarChartLegendTitleModule, DxoPolarChartLegendTitleSubtitleComponent, DxoPolarChartLegendTitleSubtitleModule, DxoPolarChartLengthComponent, DxoPolarChartLengthModule, DxoPolarChartLoadingIndicatorComponent, DxoPolarChartLoadingIndicatorModule, DxoPolarChartMarginComponent, DxoPolarChartMarginModule, DxoPolarChartMinVisualRangeLengthComponent, DxoPolarChartMinVisualRangeLengthModule, DxoPolarChartMinorGridComponent, DxoPolarChartMinorGridModule, DxoPolarChartMinorTickComponent, DxoPolarChartMinorTickIntervalComponent, DxoPolarChartMinorTickIntervalModule, DxoPolarChartMinorTickModule, DxoPolarChartPointBorderComponent, DxoPolarChartPointBorderModule, DxoPolarChartPointComponent, DxoPolarChartPointHoverStyleComponent, DxoPolarChartPointHoverStyleModule, DxoPolarChartPointModule, DxoPolarChartPointSelectionStyleComponent, DxoPolarChartPointSelectionStyleModule, DxoPolarChartPolarChartTitleComponent, DxoPolarChartPolarChartTitleModule, DxoPolarChartPolarChartTitleSubtitleComponent, DxoPolarChartPolarChartTitleSubtitleModule, DxoPolarChartSelectionStyleComponent, DxoPolarChartSelectionStyleModule, DxoPolarChartSeriesBorderComponent, DxoPolarChartSeriesBorderModule, DxoPolarChartSeriesTemplateComponent, DxoPolarChartSeriesTemplateModule, DxoPolarChartShadowComponent, DxoPolarChartShadowModule, DxoPolarChartSizeComponent, DxoPolarChartSizeModule, DxoPolarChartStripLabelComponent, DxoPolarChartStripLabelModule, DxoPolarChartStripStyleComponent, DxoPolarChartStripStyleLabelComponent, DxoPolarChartStripStyleLabelModule, DxoPolarChartStripStyleModule, DxoPolarChartSubtitleComponent, DxoPolarChartSubtitleModule, DxoPolarChartTickComponent, DxoPolarChartTickIntervalComponent, DxoPolarChartTickIntervalModule, DxoPolarChartTickModule, DxoPolarChartTitleComponent, DxoPolarChartTitleModule, DxoPolarChartTooltipBorderComponent, DxoPolarChartTooltipBorderModule, DxoPolarChartTooltipComponent, DxoPolarChartTooltipModule, DxoPolarChartValueAxisComponent, DxoPolarChartValueAxisModule, DxoPolarChartValueErrorBarComponent, DxoPolarChartValueErrorBarModule, DxoPolarChartVisualRangeComponent, DxoPolarChartVisualRangeModule, DxoPolarChartWholeRangeComponent, DxoPolarChartWholeRangeModule };
